import * as APIRoutes from '@mm/api-routes';
import commonHandler from '../errorHandlers/common-handler';
import {
  TwilioAreaCodes,
  TwilioGetResponse,
  TwilioNumber,
} from '../interfaces/twilio';
import AuthenticatedController from './AuthenticatedController';

export default class TwilioController extends AuthenticatedController {
  static async getAll(facebookPageId: number): Promise<TwilioGetResponse> {
    return super.get(APIRoutes.TWILIO(facebookPageId));
  }

  static async deletePhonenumber(facebookPageId: number): Promise<any> {
    const response: TwilioGetResponse = await super.delete(
      APIRoutes.DELETE_PHONE_NUMBER(facebookPageId),
    );

    return response;
  }

  static async update(
    facebookPageId: number,
    payload: { testNumbers?: (null | string)[]; callForwardingNumber?: string },
  ) {
    try {
      return await super.put(APIRoutes.TWILIO(facebookPageId), payload);
    } catch (err) {
      commonHandler(err);
    }
  }

  static async activatePage(
    facebookPageId: number,
    restore: boolean,
    params: { numberKind?: string; number?: string },
  ): Promise<TwilioGetResponse> {
    const apiRoute = restore
      ? APIRoutes.TWILIO_RESTORE
      : APIRoutes.TWILIO_ACTIVATE;
    return super.post(apiRoute(facebookPageId), params);
  }

  static async getCountryCodes(
    countryCodes: string[],
  ): Promise<TwilioAreaCodes[]> {
    const countryCodeLookups = [] as Promise<any>[];
    for (const countryCode of countryCodes) {
      countryCodeLookups.push(
        super.get(APIRoutes.TWILIO_AREA_CODES(countryCode)),
      );
    }

    const response = await Promise.all(countryCodeLookups);

    return response || [];
  }

  static async getAvailableNumbers(
    facebookPageId: number,
    countryCode: string,
    areaCode: string,
    pageSize: number = 6,
  ): Promise<TwilioNumber[]> {
    const response: TwilioGetResponse = await super.get(
      APIRoutes.TWILIO_GET_AVAILABLE_NUMBERS(
        facebookPageId,
        countryCode,
        areaCode,
        pageSize,
      ),
    );

    return response && response.numbers ? response.numbers : [];
  }
}
